import { checkboxAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, } from "@chakra-ui/styled-system";
import { textStyles } from "../../../../theme/foundations/generated";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(["wrapper", "helpText", ...parts.keys]);
const baseStyle = definePartsStyle(({ isReadOnly }) => ({
    wrapper: {
        display: "flex",
        flexDirection: "column",
    },
    label: {
        color: "semantic.text.primary",
        display: "flex",
        alignItems: "center",
    },
    container: {
        cursor: isReadOnly ? "auto" : "pointer",
        display: "flex",
        alignItems: "start",
    },
    control: {
        w: "6",
        h: "6",
        display: "flex",
        alignItem: "center",
        justifyContent: "center",
        border: "2px solid",
        borderColor: "semantic.border.primary",
        borderRadius: 0,
        backgroundColor: "semantic.surface.1",
        _hover: {
            borderColor: "semantic.interactive.primary",
            backgroundColor: "semantic.cta.secondaryHover",
        },
        _focusVisible: {
            outline: "3px solid",
            outlineOffset: "1px",
            outlineColor: "semantic.outline.focus",
            boxShadow: "none",
            borderColor: "semantic.interactive.primary",
        },
        _checked: {
            backgroundColor: "semantic.surface.1",
            borderColor: "semantic.interactive.primary",
            _hover: {
                backgroundColor: "semantic.cta.secondaryHover",
                borderColor: "semantic.interactive.primary",
            },
        },
        _active: {
            borderColor: "semantic.cta.secondaryPressed",
        },
        _disabled: {
            border: "2px solid",
            color: "semantic.border.disabled",
            backgroundColor: "semantic.surface.1",
            _checked: {
                border: "2px solid",
                borderColor: "semantic.border.disabled",
                backgroundColor: "semantic.surface.1",
            },
            _hover: {
                border: "2px solid",
                borderColor: "semantic.border.disabled",
                backgroundColor: "semantic.surface.1",
            },
            _active: {
                color: "semantic.icon.disabled",
            },
        },
        _readOnly: {
            borderColor: "semantic.border.primary",
            backgroundColor: "semantic.surface.1",
            _hover: {
                borderColor: "semantic.border.primary",
                backgroundColor: "semantic.surface.1",
            },
        },
        _invalid: {
            borderColor: "semantic.border.error",
            backgroundColor: "semantic.background.error",
            _hover: {
                "& + .chakra-checkbox__label": {
                    color: "semantic.interactive.primary",
                },
            },
            _focusVisible: {
                borderColor: "semantic.border.error",
                "& + .chakra-checkbox__label": {
                    color: "semantic.interactive.primary",
                },
            },
        },
        _indeterminate: {
            background: "none",
            backgroundColor: "semantic.surface.1",
            color: "semantic.interactive.primary",
            borderColor: "semantic.interactive.primary",
            _active: {
                color: "semantic.cta.secondaryPressed",
            },
            _readOnly: {
                color: "semantic.icon.secondary",
            },
        },
    },
    icon: {
        position: "relative",
        height: "14px",
        width: "14px",
    },
    helpText: Object.assign(Object.assign({ mt: "0.125rem", height: "1rem" }, textStyles.body.smallDemibold), { color: "semantic.text.error" }),
}));
const sizes = {
    large: definePartsStyle({
        label: Object.assign({}, textStyles.body.largeDemibold),
    }),
    medium: definePartsStyle({
        label: Object.assign({ paddingTop: "0.5" }, textStyles.body.mediumDemibold),
    }),
    small: definePartsStyle({
        label: Object.assign({ paddingTop: "1" }, textStyles.body.smallDemibold),
    }),
};
const checkboxTheme = defineMultiStyleConfig({
    baseStyle,
    sizes,
    defaultProps: {
        size: "medium",
    },
});
export default checkboxTheme;
//# sourceMappingURL=Checkbox.default.js.map